import React from "react";
import { Form, Switch } from "antd";

export default function SwitchInput({
  getFieldDecorator,
  callback = () => {},
  label,
  name,
  size = "default",
  setFieldsValue,
  disabled = false,
  initialValue = false,
}) {
  const handleChange = (checked) => {
    setFieldsValue({
      [name]: checked,
    });

    callback(checked, name);
  };

  return (
    <Form.Item>
      <div className="SwitchInput">
        {getFieldDecorator(name, {
          initialValue,
          valuePropName: "checked",
        })(<Switch size={size} onChange={handleChange} disabled={disabled} />)}

        <span>{label}</span>
      </div>
    </Form.Item>
  );
}
